(function($) {
  $.fn.musicList = (options) => {
    const arrMovie = new Array()
    const elSqueeze1 = document.querySelector('.js-squeeze1')
    const elSqueeze2 = document.querySelector('.js-squeeze2')
    const elResult = document.querySelector('.js-result')
    const state = {
      selectType: '',
      selectValue1: '',
      selectValue2: ''
    }
    const dataMap = new WeakMap()

    const getJSON = (filePath) => {
      return $.ajax({
        type: 'GET',
        url: filePath,
        dataType: 'json',
        cache: false
      })
    }

    const setData = (filePath) => {
      const json = getJSON(filePath)
      json.then(
        (data) => {
          $.extend(arrMovie, data)

          elSqueeze1.addEventListener('change', () => {
            state.selectType = 'genre'
            state.selectValue1 = elSqueeze1.value
            state.selectValue2 = elSqueeze2.value
            renderSelectResult()
          })

          elSqueeze2.addEventListener('change', () => {
            state.selectType = 'genre'
            state.selectValue1 = elSqueeze1.value
            state.selectValue2 = elSqueeze2.value
            renderSelectResult()
          })

          // First launch
          setTimeout(() => {
            state.selectType = 'genre'
            state.selectValue1 = '各大学の最新動画'
            state.selectValue2 = ''
            renderSelectResult()
          }, 500);
        },
        (error) => {
          console.log('読み込みに失敗しました')
        }
      )
    }

    const renderSelectResult = () => {
      const arrMovieOutput = new Array()
      const elList = document.createElement('ul')

      arrMovie.filter(item => item[state.selectType].includes(state.selectValue1)).forEach(item => {
        arrMovieOutput.push(item)
      })

      arrMovieOutput.filter(item => item[state.selectType].includes(state.selectValue2)).forEach(item => {
        const elItem = document.createElement('li')
        dataMap.set(elItem, { item })
        elItem.innerHTML = `<div class="movie-iframe"><iframe width="560" height="315" src="https://www.youtube.com/embed/${item.url}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe></div><p class="movie-title">${item.title}</p><p class="movie-name"><a href="/university/detail/${item.id}">${item.name}</a></p>`
        elList.appendChild(elItem)
      })

      elResult.innerHTML = ''
      elResult.appendChild(elList)
    }

    // initial value
    let defaults = {
      filePath: ''
    }
    let params = $.extend(defaults, options)
    setData(params.filePath)
  }
})(jQuery)